import { makeStyles } from '@material-ui/styles';
import { Skeleton } from '@bizzabo/design-system';

const ManageLoader: React.FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <Skeleton className={classes.title} />
            <Skeleton className={classes.timezone} />
            <Skeleton className={classes.nowTitle} />
            <Skeleton className={classes.nowCard} />
            <Skeleton className={classes.inviteTitle} />
            <Skeleton className={classes.inviteCard} />
            <Skeleton className={classes.scheduledTitle} />
            {[...Array(2).keys()].map(item => {
                return (
                    <div className={classes.item} key={item}>
                        <Skeleton className={classes.text} />
                        <div className={classes.row}>
                            <Skeleton className={classes.avatar} />
                            <div className={classes.userBadge}>
                                <Skeleton className={classes.userName} />
                                <Skeleton className={classes.userDetails} />
                            </div>
                        </div>
                        <Skeleton className={classes.text} />
                    </div>
                );
            })}
        </div>
    );
};

const useStyles = makeStyles(
    () => ({
        container: {
            padding: '0 30px',
        },
        title: {
            width: '50%',
            height: 27,
            margin: '40px 0 10px',
        },
        timezone: {
            height: 20,
            marginBottom: 20,
        },
        nowTitle: {
            height: 24,
            width: '20%',
        },
        nowCard: {
            height: 154,
            margin: '20px 0 40px',
        },
        inviteTitle: {
            height: 24,
            width: '40%',
        },
        inviteCard: {
            height: 88,
            margin: '20px 0 40px',
        },
        scheduledTitle: {
            height: 24,
            width: '60%',
        },
        item: {
            padding: '20px 0',
            borderBottom: 'solid 1px #DEDEDE',
        },
        text: {
            height: 18,
        },
        row: {
            display: 'flex',
            alignItems: 'center',
            margin: '10px 0',
        },
        userBadge: {
            flex: 1,
        },
        avatar: {
            width: 32,
            height: 32,
            borderRadius: 50,
            marginRight: 8,
        },
        userName: {
            width: '30%',
            height: 18,
            marginBottom: 4,
        },
        userDetails: {
            width: '60%',
            height: 18,
        },
    }),
    { classNamePrefix: 'meetings-manage-loader' }
);

export default ManageLoader;
